const getWheelSpinStatusColor = (status) => {
  switch (status) {
    case 'success':
      return {
        color: '#fff',
        background: '#28a745',
      }
    case 'pending':
      return {
        color: '#fff',
        background: '#ffa500',
      }
    case 'failed':
      return {
        color: '#fff',
        background: '#dc3545',
      }
    default:
      return {
        color: '#999',
        background: '#fff',
      }
  }
}

export { getWheelSpinStatusColor }
